"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtractYears = exports.getYearsDifference = exports.MILLISECONDS_IN_YEAR = exports.MILLISECONDS_IN_SECOND = exports.SECONDS_IN_MINUTE = exports.MINUTES_IN_HOUR = exports.HOURS_IN_DAY = exports.DAYS_IN_YEAR = void 0;
exports.DAYS_IN_YEAR = 365;
exports.HOURS_IN_DAY = 24;
exports.MINUTES_IN_HOUR = 60;
exports.SECONDS_IN_MINUTE = 60;
exports.MILLISECONDS_IN_SECOND = 1000;
exports.MILLISECONDS_IN_YEAR = exports.MILLISECONDS_IN_SECOND *
    exports.SECONDS_IN_MINUTE *
    exports.MINUTES_IN_HOUR *
    exports.HOURS_IN_DAY *
    exports.DAYS_IN_YEAR;
/**
 * Return the number of years between the provided date and the current date.
 */
const getYearsDifference = (date, now = new Date()) => {
    const millisToNow = now.getTime() - date.getTime();
    return millisToNow / exports.MILLISECONDS_IN_YEAR;
};
exports.getYearsDifference = getYearsDifference;
/**
 * Return a new date with the provided number of years subtracted from the provided date.
 */
const subtractYears = (date, years) => {
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const newYear = year - years;
    const newDate = new Date(newYear, month, day, hour, minute, second);
    return newDate;
};
exports.subtractYears = subtractYears;
